module.exports = __webpack_public_path__ + "img/baska_2.c255bc31.webp";